/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_R_AgentsInputs */

const en_mk_cmp_r_agents = /** @type {(inputs: Mk_Cmp_R_AgentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agents as assignees`)
};

const id_mk_cmp_r_agents = /** @type {(inputs: Mk_Cmp_R_AgentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agen sebagai penanggung jawab`)
};

/**
* | output |
* | --- |
* | "Agents as assignees" |
*
* @param {Mk_Cmp_R_AgentsInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_r_agents = /** @type {((inputs?: Mk_Cmp_R_AgentsInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_R_AgentsInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_r_agents(inputs)
	return en_mk_cmp_r_agents(inputs)
});